import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Divider, Grid } from '@material-ui/core'
import Loader from '../../Loader/Loader'
import ChooseAPaymentMethod from './ChooseAPaymentMethod'
import OrderSummary from './OrderSummary'
import SignAcceptanceCriteria from './SignAcceptanceCriteria'
import { getProjectDetails } from '../../../actions/projectActions'
import { PROJECT_DOCUMENT_SIGNED_RESET } from '../../../constants/projectConstants'

const ProjectSignAndPay = ({
  setShowSignAndPayModal,
  handleProceedClick,
  bindPurchaseOrderNumber,
  purchaseOrderFiles,
  setPurchaseOrderFiles,
  setPaymentMethod,
  paymentError,
  purchaseOrderNumber,
  processingPayment,
}) => {
  const dispatch = useDispatch()

  const { project } = useSelector((state) => state.projectDetails)
  const { success: docSignedSuccess } = useSelector(
    (state) => state.projectDocumentSigned
  )
  const { loading: addPODocsLoading } = useSelector(
    (state) => state.projectAddPODocs
  )

  useEffect(() => {
    if (docSignedSuccess) {
      dispatch(getProjectDetails(project._id))
      dispatch({ type: PROJECT_DOCUMENT_SIGNED_RESET })
    }
  }, [dispatch, docSignedSuccess, project])

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={8}>
          <h2 className="m-b-24 fs20">Proceed with quote</h2>

          <Divider />

          <SignAcceptanceCriteria />

          <Divider />

          <ChooseAPaymentMethod
            bindPurchaseOrderNumber={bindPurchaseOrderNumber}
            files={purchaseOrderFiles}
            setFiles={setPurchaseOrderFiles}
            setPaymentMethod={setPaymentMethod}
            paymentError={paymentError}
          />

          <Divider />
        </Grid>

        <Grid item xs={4}>
          <OrderSummary charge={project.charges[0].price} />
        </Grid>
      </Grid>
      <div className="flex flex-end m-t-40">
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setShowSignAndPayModal(false)}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={purchaseOrderNumber === '' || addPODocsLoading}
          variant="contained"
          className="m-l-32"
          onClick={handleProceedClick}
        >
          {processingPayment || addPODocsLoading ? <Loader /> : 'Proceed'}
        </Button>
      </div>
    </>
  )
}

export default ProjectSignAndPay
